export default __webpack_public_path__ + "static/media/dieppe10.584c7bba.jpg";